import { getFirstObjectValue, getObjectValue } from "../utils/objectPath";
import { PdfComposer } from "./pdf";
import { PdfContext } from "./types";
import { first, isArray, isObject, isStr } from "rant-utils";
import { createScriptEngine, CustomScriptFunctions } from "../utils/script";
import { AddressCustomScriptFunctions, NameCustomScriptFunctions } from "../../data-entry/runScript";
import { entityName, formatter, getEntityNameFromHolders, individualName } from "../../formatters/format";

// export function runScriptPdf(
// 	script: string,
// 	composer?: PdfComposer,
// 	currentContext?: PdfContext,
// 	scriptContext?: ScriptContext,
// ) {
// 	debugger;
// 	return undefined as any;
// }

const { 
	get,
	getCount,
	getCountsOf,
	...fnsToKeep 
} = CustomScriptFunctions;

export const PdfCustomScriptFunctions = {
	...fnsToKeep,
	formatter,
}

export function createPdfScriptEngine(
	composer?: PdfComposer,
) {





	return createScriptEngine({
		customFunctions: {
			...PdfCustomScriptFunctions,
		
		},

		onCreateScopeDependentFunctions: (globalScope) => {

			const dataWindows = globalScope._dataWindows;
			const dataWindowsOrder = globalScope._dataWindowsOrder;

			function get(prop: string) { 
				// try and find first occurence
		
				// if prop starts with a "." then want to look for an exact match within the scope
				const exact = prop.startsWith(".");
				if (exact) prop = prop.substring(1);
		
				const parts = prop.split(".");
				const firstPart = first(parts);
				if (firstPart) parts.splice(0,1);


				// if (prop === "partyCounts") {
				// 	debugger;
				// }
		
				// NOTE: the last scope item will be most relevant so look there first and progressively work back to broader scope
				for(let i=dataWindowsOrder.length-1;i>=0;i--) {
					const thisScope = dataWindows[dataWindowsOrder[i]];

					if (!thisScope) continue;
		
					if (exact) {
						const result = getObjectValue(thisScope, prop);
						if (result) return result;
		
					} else {
						// search
						if (firstPart === thisScope.name) {
							// matched scope item, so look exact from this point
							const result = getObjectValue(thisScope.obj, parts.join("."));
							if (result) return result;
						} else {
							// look anywhere
							const result = getFirstObjectValue(thisScope, prop);
							if (result) return result;	
						}
		
					}
				 }
				
				// didn't find anything
		
				// auto get value?
				if (prop === "dateRegistered") {
					return new Date();
				}
		
				return undefined;
			}
		
			// get the number of items in an array
			function getCount(prop: string) {
				const v = get(prop);
				if (Array.isArray(v)) {
					return v.length;
				} else {
					return 0;
				}
			}
		
			// find the count of how many array elements match a specific criteria
			function getCountsOf(arrayProp: string, props: string[]) {
				const arr = get(arrayProp);
		
				const counts = {} as any;
				for(let p of props) {
					counts[p] = 0;
				}
		
				if (Array.isArray(arr)) {
					for(let a of arr) {
						for(let p of props) {
							if (a[p]) counts[p]++;
						}
					}
				}
		
				return counts;
			}
		
			function getContainer(listProp: string, containerID: string) {
				// first get the container
				const arr = get(listProp);
				if (!arr) return undefined;
		
				for(let a of arr) {
					if (a.containerID === containerID) {
						return a;
					}
				}
		
				return undefined;
			}
						
			function entityNameFromHolders(holdersProp: string | any, entitiesFrom: string, options?: {
				specificHolderIndex?: number,
				jointWords1?: string,
				jointWords2?: string,
				share?: any, // object containing the isBeneficiallyHeld attribute
			}) {
				let holdersContext;
				let holders;
		
				if (isArray(holdersProp)) {
					holders = holdersProp;
				
				} else if (isObject(holdersProp) && holdersProp.holders) {
					holders = holdersProp.holders;
					holdersContext = holdersProp;

				} else {
					holders = get(holdersProp);

				}
		
				if (!holders) return undefined;

				if (!holdersContext) holdersContext = (dataWindows.share ? dataWindows.share : options?.share);

				const parties = get(entitiesFrom);

				return getEntityNameFromHolders(holdersContext, holders, parties, options);
			}
						
			function entityAddressFromHolders(holdersProp: string | any, entitiesFrom: string, options?: {
				specificHolderIndex?: number,
				primaryOnly?: boolean,
			}) {
				let contextObject;
				let holders;
		
				if (isArray(holdersProp)) {
					holders = holdersProp;
				
				} else if (isObject(holdersProp) && holdersProp.holders) {
					holders = holdersProp.holders;
					contextObject = holdersProp;

				} else {
					holders = get(holdersProp);

				}

				if (!holders) return undefined;
		
				let specificHolderIndex;
				let primaryOnly;
				if (options) {
					specificHolderIndex = options.specificHolderIndex;
					primaryOnly = options.primaryOnly;
				}
		
				const ents = [];
		
				if (primaryOnly && holders.length > 1) {
					const pa = get("share.primaryAddress");
					
					if (pa === "other") {
						const other = get("share.jointAddressOther");
						const addr = AddressCustomScriptFunctions.entityAddress(other)!;
						ents.push(addr);
		
					} else if (pa) {
						const container = getContainer(entitiesFrom, pa);
						const ent = getFirstObjectValue(container, "entity");
						const addr = AddressCustomScriptFunctions.entityAddress(ent)!;
						ents.push(addr);	
					}
		
				} else {
					for (let i=0;i<holders.length;i++) {
						const h = holders[i];
		
						if (specificHolderIndex !== undefined && specificHolderIndex >= 0 && specificHolderIndex !== i) {
							continue;
						}
		
						const container = getContainer(entitiesFrom, h);
						const ent = getFirstObjectValue(container, "entity");
						const addr = AddressCustomScriptFunctions.entityAddress(ent)!;
						ents.push(addr);
					}
				}
		
				if (ents.length === 1) {
					return ents[0];
				} else {
					return ents.join("\n\n");
				}
			}
		
			function refLookup(prop: string, refTable: string, compareWithColName?: string, returnColName?: string) {
				//debugger;

				if (!globalScope || !globalScope.data || !globalScope.data.refs) {
					debugger;
					return undefined;
				}
		
				const val = get(prop);
		
				const refs = globalScope.data.refs;
				const ref = refs[refTable];
				if (!ref) return undefined;
				const refData = ref.data;
				if (!refData) return undefined;
		
				// TODO: prob need options for choosing column (or maybe even specifying the field def to source display column from)
		
				if (!compareWithColName) compareWithColName = "ID";
				if (!returnColName) returnColName = "Name";
		
				let compareWithCol, returnCol;
				for(let c of refData.columns) {
					if (c.title === compareWithColName) compareWithCol = c.id;
					if (c.title === returnColName) returnCol = c.id;
				}
		
				for(let r of refData.rows) {
					if (r[compareWithCol] === val) return r[returnCol];
				}
		
				return "";
			}	

			// get list of unique:
			//	 holders + share class + beneficially held details
			//	
			function createFolios() {

				interface Folio {
					id: string,
					folioNumber: string,
					folioPrefix: string,

					items: any[],
				}

				const shares = get("shares");
				if (!shares) return;

				const folios: Folio[] = [];
				const foliosMap = {} as any;

				// counters are unique to share class
				const certCounters = {} as any;
				const folioCounters = {} as any;

				for(let share of shares) {
					// sort holders
					const sorted = [...share.holders];
					sorted.sort();

					const beneficialDetails = (
						share.isBeneficiallyHeld
						? ("Y:" + individualName(share.trustee)) 
						: "N"
					);

					// want the share class to be ORD first
					const shareClass = (share.shareClass === "ORD" ? "" : share.shareClass);

					const folioID = share.shareClass + "-" + sorted.join(",") + "-" + beneficialDetails;

					let fCount = folioCounters[share.shareClass];
					if (!fCount) {
						fCount = 1;
						folioCounters[share.shareClass] = 1;
					}
					folioCounters[share.shareClass]++;

					const folioNumber = shareClass + fCount;

					if (!foliosMap[folioID]) {
						const f = {
							id: folioID,
							folioNumber,
							folioPrefix: shareClass,
							items: [],
							certificateCounter: 1,
						};
						foliosMap[folioID] = f;
						folios.push(f);
					}

					const folio = foliosMap[folioID];
					folio.items.push(share);

					share.folioNumber = folio.folioNumber;

					if (!certCounters[share.shareClass]) {
						certCounters[share.shareClass] = 1;
					}	
					share.certificateNumber = shareClass + certCounters[share.shareClass]++;
				}

				folios.sort((a, b) => {
					let result = (a.folioNumber.localeCompare(b.folioNumber));
					return result;
				});

				return folios;
			}
		
			return {
				get,
				getCount,
				getCountsOf,
				getContainer,
				entityNameFromHolders,
				entityAddressFromHolders,
				refLookup,
				createFolios,
			};

		},

	});

}

// export function runScript(
// 	script: string,
// 	composer?: PdfComposer,
// 	currentContext?: PdfContext,
// 	scriptContext?: ScriptContext,
// ) {

// 	const scope = scriptContext?.scope!;



// 	const defaultScope = {
// 		...getScriptUtils(),
// 	};

// 	const executionScope: ScopeObject[] = [
// 		{
// 			name: "defaultScope",
// 			obj: defaultScope,
// 		},
// 		{
// 			name: "currentContext",
// 			obj: currentContext,
// 		},
// 		{
// 			name: "entityNameFunctions",
// 			obj: entityNameFunctions,
// 		}
// 	];

// 	// if (scriptContext.scope.length > 0) {
// 	// 	for(let i=0;i<scriptContext.scope.length;i++) {
// 	// 		const s = scriptContext.scope[i];

// 	// 		executionScope.push({
// 	// 			name: `scriptContext.scope[${i}]`,
// 	// 			obj: s,
// 	// 		});
// 	// 	}
// 	// }

// 	let result: any;
// 	try {
// 		const scope = scriptContext!.scope ? scriptContext!.scope : undefined;

// 		const prepared = prepareScript(script, executionScope, scope);
// 		const namedScopeObjects = scope;
// 		result = eval(prepared);
// 	} catch (e) {
// 		console.error("ERROR running script: " + e);
// 		debugger;
// 	}
// 	return result;
// }
